<template>
  <WithBackdrop
    :backdrop="data?.fields?.backdrop"
    :class="[$style.config, $style.wrap]"
  >
    <div :class="$style.inner">
      <header :class="$style.header">
        <BaseHeading size="h4" as="h2" :class="$style.heading">
          {{ data?.fields?.header }}
        </BaseHeading>
        <MarkedParser
          :md="data?.fields?.copy"
          :class="['u-fs-p1', $style.copy]"
        />
      </header>
      <div :class="$style.linkables">
        <BaseButton
          v-for="linkable in computedLinkables"
          :id="linkable?.fields?.identifier"
          :key="linkable?.sys?.id"
          :to="linkable?.fields?.link"
          presentation="default"
          size="default"
          :target="linkable?.fields?.target"
          type="button"
          :class="$style.linkable"
        >
          {{ linkable?.fields?.label }}

          <span :class="$style.trailing">
            <IconLinkableArrowRight :class="$style.icon" />
          </span>
        </BaseButton>
      </div>
    </div>
  </WithBackdrop>
</template>

<script setup lang="ts">
import type { TypeContentBlockWithoutUnresolvableLinksResponse } from '~/types/contentful'

const props = defineProps<{
  data: TypeContentBlockWithoutUnresolvableLinksResponse
}>()

const computedLinkables = computed(() =>
  props.data?.fields?.references?.filter?.(instanceOfLinkable),
)
</script>

<style lang="scss" module>
.config {
  @include breakpoint-variables(
    '--si-wrap-padding',
    (
      base: 45px 20px,
      md: 60px 20px,
    )
  );
}

.wrap {
  padding: var(--si-wrap-padding);
}

.inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  max-width: 800px;
  margin: 0 auto;

  @include media('md') {
    flex-direction: row;
    gap: 90px;
    max-width: 1000px;
  }
}

.header {
  text-align: center;
  color: var(--white);
  width: 100%;

  @include media('md') {
    text-align: left;
  }
}

.heading {
  margin-bottom: 10px;
}

.linkables {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.linkable {
  position: relative;
  border: 0;
  overflow: hidden;
  justify-content: flex-start;
  padding-right: 40px;

  &:hover .trailing {
    background: var(--purple);
  }
}

.trailing {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;

  display: flex;
  align-items: center;
  padding: 0 10px;
  background: #444276;
}

.icon {
  height: 9px;
  width: 11px;

  @include media('xs') {
    height: 12px;
    width: 15px;
  }
}
</style>
